/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"AudienceSegmentationContextProviderQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmbedContainerQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"InvitedAppShortcutsRecommendationsQuery",
	"IsSuperAdminQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RecentlyUpdatedMacroQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WebStorageCategories",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_3",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_163",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_165",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_166",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadOutgoingLinksQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAccessRequestSettingsQuery",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useChangeHistoryDataQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentByLabelDataQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useContributorsDataQuery",
	"useDetailsSummaryADFQueryQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePopularLabelsDataQuery",
	"usePopularLabelsDataSpaceIdQuery",
	"usePreloadCommentButtonQuery",
	"useProfileInfoUserContextQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery",
	"useViewPdfDataQuery",
	"useViewXlsDataQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "9717bb94f9fdfafd67cbeeff6fdfdf4720df7dfccf17",
	"prod-apne2": "9f1fbbb4f9bdfafd67cbeeff7fdfff4621df79fdcf07",
	"prod-apse": "971fbbfcf9bdfafd67cbefff7fdfff4720ff79fddf17",
	"prod-apse2": "979fbbbcf9bdfafdffebeeff7fdfff4720ff79fdff17",
	"prod-apsouth": "9737bb9cf9bdfafd67ebeeff7fdfff66205f39f4ef07",
	"prod-cacentral": "9797bbdcf9fdfaffe7ebefff7fdfff4620ff3ffdef07",
	"prod-east": "9fdffb34fbfdfafffffbefffffffff472eff7ffffd1f",
	"prod-eucentral": "9fdfbfbcf3bdfafdffcbeeffffffff4727ff79feff1f",
	"prod-eucentral2": "9797bb14f9bcfafd77c9aeff7fdfff0620ff19fd4f07",
	"prod-euwest": "9f9fffb4fbfdfaffffefeeffffffff4727ff79fefd1f",
	"prod-euwest2": "9797bbf4f9fdfaffe7ebeeff7fdfff4622ff39fd9f17",
	"prod-west2": "9f9fbf34fffdfaff7febeeffffdfff4726ff7ffddf1f",
	"stg-east": "00803a00b826a22e4000ec798d82d604007402a00005"
};

export const generatedAt: string | null = "2026-09-18T03:06:07.130Z";

export const sourceUrl: string | null = "https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json";
